/** Holds all route names available in the app */
export default class LocalizationConstants {
  public static DEFAULT_LANGUAGE_CODE = "EN";
  public static LOCATION_DELETE_TITLE = "location.deletetitle";
  public static LOCATION_DELETE_DESCRIPTION = "location.deletedescription";
  public static LOCATION_DELETE_CONFIRMATION = "location.deleteconfirmation";
  public static LOCATION_CREATE = "location.create";
  public static LOCATION_NO_LOCATIONS_FOUND = "location.nolocationsfound";
  public static LOCATION_ACTIONS = "location.actions";
  public static LOCATION_CHANGE = "location.change";
  public static LOCATION_REMOVE_TOOL = "location.removetool";
  public static LOCATION_TOOLS_AT_LOCATION = "location.toolsatlocation";
  public static LOCATION_TOOLS_COUNT = "location.toolscount";
  public static PENDING_USERS_CONFIRM_REMOVE_FROM_LIST = "pendingusers.confirmremovefromlist";
  public static APPROVED_SERVICE_PRICE_PAGE_TITLE = "approvedServicePrice.pageTitle";
  public static APPROVED_SERVICE_PRICE_FAM = "approvedserviceprice.fam";
  public static APPROVED_SERVICE_PRICE_SEARCH = "approvedserviceprice.search";
  public static APPROVED_SERVICE_PRICE_MAX_SERVICE_PRICE = "approvedserviceprice.maxservperc";
  public static APPROVED_SERVICE_PRICE_PO_MANDATORY = "approvedserviceprice.pomandatory";
  public static APPROVED_SERVICE_PRICE_ADD_NEW_ITEM = "approvedserviceprice.addNewItem";
  public static ADMIN_PAGE_TITLE = "admin.pageTitle";
  public static ADMIN_USERS = "admin.users";
  public static ADMIN_LOCALIZATION = "admin.localization";
  public static ADMIN_PENDING_USERS = "admin.pendingusers";
  public static ADMIN_REMINDER_LIST = "admin.reminderlist";
  public static ADMIN_VISIBLE_EVENT = "admin.visibleevent";
  public static ADMIN_DOCUMENT_FILTER = "admin.documentfilter";
  public static ADMIN_REQUESTED_SERVICE_LIST = "admin.requestedservicelist";
  public static ADMIN_APPROVED_MAX_SERVICE_PRICE = "admin.approvedmaxserviceprice";

  // Release 2.2.2
  public static ADMIN_CONTACTS = "admin.contacts";
  public static CONTACTS_PAGE_TITLE = "contacts.pageTitle";
  public static TECH_COVER_CONTACT_FAM_CODE = "contacts.famCode";
  public static TECH_COVER_CONTACT_EMAIL = "contacts.email";
  public static TECH_COVER_CONTACT_PHONE = "contacts.phone";
  public static TECH_COVER_CONTACT_ADD_CONTACT = "contacts.addContact";
  public static TECH_COVER_CONTACT_PHONE_REQUIRED_ERROR = "contacts.phoneRequiredError";
  public static TECH_COVER_CONTACT_EMAIL_REQUIRED_ERROR = "contacts.emailRequiredError";
  public static TECH_COVER_CONTACT_EMAIL_INVALID_ERROR = "contacts.emailInvalidError";
  public static TECH_COVER_CONTACT_FAM_CODE_REQUIRED_ERROR = "contacts.famCodeRequiredError";
  public static TECH_COVER_CONTACT_ADD_CONTACT_FAM_PLACEHOLDER =
    "contacts.addContactFamPlaceholder";
  public static TECH_COVER_CONTACT_REMOVE_CONTACT_DIALOG_TITLE =
    "contacts.removeContactDialogTitle";
  public static TECH_COVER_CONTACT_REMOVE_CONTACT_DIALOG_CONTENT =
    "contacts.removeContactDialogContent";
  public static OVERVIEW_TECH_COVER_TITLE = "overview.techCoverTitle";
  public static OVERVIEW_TECH_COVER_ACTIVE_TICKETS = "overview.techCoverActiveTickets";
  public static OVERVIEW_SOFTWARE_SUPPORT = "overview.softwareSupport";
  public static OVERVIEW_TECH_COVER_EMAIL = "overview.techCoverEmail";
  public static OVERVIEW_TECH_COVER_PHONE = "overview.techCoverPhone";
  public static VALIDATION_FAM_CODE_INVALID = "validation.famCodeInvalid";
  public static TECH_COVER_PAGE_TITLE = "techCover.pageTitle";
  public static TECH_COVER_RECENT_UPDATES = "techCover.recentUpdates";
  public static TECH_COVER_RECENT_UPDATES_NO_CONTENT = "techCover.recentUpdatesNoContent";
  public static TECH_COVER_SUPPORT_TICKETS = "techCover.supportTickets";
  public static TECH_COVER_SOFTWARE_SUPPORT = "techCover.softwareSupport";
  public static TECH_COVER_TICKET_SUBJECT = "techCoverTicket.subject";
  public static TECH_COVER_TICKET_PRODUCT_NAME = "techCoverTicket.productName";
  public static TECH_COVER_TICKET_STATUS = "techCoverTicket.status";
  public static TECH_COVER_TICKET_CREATED_DATE = "techCoverTicket.createdDate";
  public static TECH_COVER_TICKET_CLOSED_DATE = "techCoverTicket.closedDate";
  public static TECH_COVER_TICKET_NEW_STATUS = "techCoverTicket.newStatus";
  public static TECH_COVER_TICKET_CLOSED_STATUS = "techCoverTicket.closedStatus";
  public static TECH_COVER_TICKET_IN_PROGRESS_STATUS = "techCoverTicket.inProgressStatus";
  public static TECH_COVER_NO_TICKETS = "techCover.noTickets";
  public static TECH_COVER_TICKET_DETAILS = "techCoverTicket.details";
  public static TECH_COVER_SOFTWARE_SOFTWARE_DESCRIPTION = "techCoverSoftware.softwareDescription";
  public static TECH_COVER_TICKET_CREATED_BY = "techCoverTicket.createdBy";
  public static TECH_COVER_NEW_TICKET_BUTTON = "techCoverTicket.newTicketButton";
  public static TECH_COVER_SOFTWARE_RELEASE_RELEASE_NOTES_BUTTON_TITLE =
    "techCovetSoftwareRelease.releaseNotesButtonTitle";
  public static TECH_COVER_SOFTWARE_RELEASE_DOWNLOAD_BUTTON_TITLE =
    "techCovetSoftwareRelease.downloadButtonTitle";

  // Release 2.2.2 end

  // Release 2.2.6

  public static ADMIN_CUSTOMERS = "admin.customers";
  public static CUSTOMER_SETTINGS_PAGE_TITLE = "customerSettings.pageTitle";
  public static CUSTOMER_SETTINGS_CUSTOMER_NAME = "customerSettings.customerName";
  public static CUSTOMER_SETTINGS_CUSTOMER_ID = "customerSettings.customerId";
  public static CUSTOMER_SETTINGS_UNIT_OF_MEASURE = "customerSettings.unitOfMeasure";
  public static CUSTOMER_SETTINGS_SHIPPING_COMPANY = "customerSettings.shippingCompany";
  public static CUSTOMER_SETTINGS_SHIPPING_ACCOUNT = "customerSettings.shippingAccount";
  public static CUSTOMER_SETTINGS_SHIPPING_ENABLED = "customerSettings.shippingEnabled";
  public static CUSTOMER_SETTING_MODAL_EDIT_CUSTOMER = "customerSettings.modalEditCustomer";
  public static CUSTOMER_SETTING_MODAL_ADD_CUSTOMER = "customerSettings.modalAddCustomer";
  public static CUSTOMER_SETTING_MODAL_SELECT_COMPANY = "customerSettings.modalSelectCompany";
  public static CUSTOMER_SETTING_MODAL_COMPANY_ID = "customerSettings.modalCompanyId";
  public static UNIT_OF_MEASURE_METRIC = "unitOfMeasure.metric";
  public static UNIT_OF_MEASURE_IMPERIAL = "unitOfMeasure.imperial";

  public static CUSTOMER_SETTINGS_SHIPPING = "customerSettings.shipping";
  public static CUSTOMER_SETTINGS_TECH_COVER = "customerSettings.techCover";
  public static CUSTOMER_SETTINGS_TECH_COVER_ENABLED = "customerSettings.techCoverEnabled";

  public static CUSTOMER_SETTINGS_INVALID_SHIPPING_DETAILS =
    "customerSettings.invalidShippingDetails";
  public static CUSTOMER_SETTINGS_INVALID_SHIPPING_DETAILS_TITLE =
    "customerSettings.invalidShippingDetailsTitle";

  // Release 2.2.6 end

  // documentFilters
  public static DOCUMENT_FILTERS_PAGE_TITLE = "documentFilters.pageTitle";
  public static DOCUMENT_FILTERS_FAM_CODE = "documentFilters.famCode";
  public static DOCUMENT_FILTERS_USER_ROLE = "documentFilters.userRole";
  public static DOCUMENT_FILTERS_NOTE = "documentFilters.note";
  public static DOCUMENT_FILTERS_NOTE_TEXT = "documentFilters.noteText";
  public static DOCUMENT_FILTERS_FILE_EXTENSION = "documentFilters.fileExtension";
  public static DOCUMENT_FILTERS_DOCUMENT_PREFIX = "documentFilters.documentPrefix";
  public static DOCUMENT_FILTERS_DOCUMENT_PREFIX_ADD_PLACEHOLDER =
    "documentFilters.addDocumentPrefixPlaceholder";
  public static DOCUMENT_FILTERS_EXISTING_FILTERS_COLUMN_NAME =
    "documentFilters.existingFiltersColumnName";

  // requestServiceList
  public static REQUESTED_SERVICE_LIST_PAGE_TITLE = "requestedServiceList.pageTitle";
  public static REQUESTED_SERVICE_LIST_FAM_CODE = "requestedServiceList.famCode";
  public static REQUESTED_SERVICE_LIST_NOTE = "requestedServiceList.note";
  public static REQUESTED_SERVICE_LIST_NOTE_TEXT = "requestedServiceList.noteText";
  public static REQUESTED_SERVICE_LIST_VALUE_COLUMN_NAME = "requestedServiceList.valueColumnName";
  public static REQUESTED_SERVICE_LIST_DISPLAY_VALUE_COLUMN_NAME =
    "requestedServiceList.displayValueColumnName";

  public static REMINDERS_ADMIN_PAGE_TITLE = "reminders.adminPageTitle";
  public static REMINDERS_PAGE_TITLE = "reminders.pageTitle";
  public static REMINDERS_BY_COUNTRY = "reminders.bycountry";
  public static REMINDERS_BY_COMPANY = "reminders.bycompany";
  public static REMINDERS_SEARCH = "reminders.search";
  public static LOCALIZATIONS_PAGE_TITLE = "localizations.pageTitle";
  public static LOCALIZATIONS_NAME_REQUIRED_ERROR = "localizations.namerequirederror";
  public static LOCALIZATIONS_ISO_CODE_LENGTH_ERROR = "localizations.isocodelengthderror";
  public static LOCALIZATIONS_ISO_CODE_REQUIRED_ERROR = "localizations.isocoderequirederror";
  public static LOCALIZATIONS_NAME = "localizations.name";
  public static LOCALIZATIONS_ADD_LANGUAGE = "localizations.addlanguage";
  public static LOCALIZATIONS_ISO_CODE = "localizations.isocode";
  public static LOCALIZATION_EDIT_PAGE_TITLE = "localization.editPageTitle";
  public static LOCALIZATION_ADD = "localization.add";
  public static LOCALIZATIONS_CREATE = "localizations.create";
  public static LOCALIZATION_ADD_PLACEHOLDER = "localization.addplaceholder";
  public static LOCALIZATION_KEY = "localization.key";
  public static LOCALIZATION_GROUP = "localization.group";
  public static LOCALIZATION_ENGLISH_PHRASE = "localization.englishPhrase";
  public static LOCALIZATION_TRANSLATED_PHRASE = "localization.translatedPhrase";
  public static PENDING_USERS_PAGE_TITLE = "pendingusers.pageTitle";
  public static PENDING_USERS_COUNTRY = "pendingusers.country";
  public static PENDING_USERS_NAME = "pendingusers.name";
  public static PENDING_USERS_EMAIL = "pendingusers.email";
  public static PENDING_USERS_COMPANY = "pendingusers.company";
  public static PENDING_USERS_REQUEST_DATE = "pendingusers.requestdate";
  public static PENDING_USERS_ADDRESS = "pendingusers.address";
  public static USER_PAGE_TITLE = "user.pageTitle";
  public static USER_PLANNING_BOARD_ROLE = "user.planningBoardRole";
  public static USER_NOT_IN_ENTRA_TITLE = "user.notInEntraTitle";
  public static USER_NOT_IN_ENTRA_MESSAGE = "user.notInEntraMessage";
  public static USER_NOT_IN_ENTRA_DELETE = "user.notInEntraDelete";
  public static USER_NAME = "user.name";
  public static USER_EMAIL = "user.email";
  public static USER_ROLE = "user.role";
  public static USER_COMPANIES = "user.companies";
  public static USER_CREATE_DATE = "user.createdate";
  public static USERS_PAGE_TITLE = "users.pageTitle";
  public static USERS_CREATE = "users.create";
  public static USERS_CREATE_IN_AZURE = "users.createInAzure";
  public static VISIBLE_EVENTS_PAGE_TITLE = "visibleevents.pageTitle";
  public static VISIBLE_EVENTS_EVENT = "visibleevents.event";
  public static VISIBLE_EVENTS_VISIBLE = "visibleevents.visible";
  public static CONTRACTS_PAGE_TITLE = "contracts.pageTitle";
  public static CONTRACT_DETAILS_PAGE_TITLE = "contracts.detailPageTitle";
  public static FIELD_SERVICE_PAGE_TITLE = "fieldservice.pageTitle";
  public static FIELD_SERVICE_DETAILS_PAGE_TITLE = "fieldservice.detailsPageTitle";
  public static PURCHASE_ORDER_PAGE_TITLE = "purchaseorder.pageTitle";
  public static SERVICE_REQUEST_PAGE_TITLE = "servicerequest.pageTitle";
  public static MY_TOOLS_PAGE_TITLE = "myTools.pageTitle";
  public static TOOLS_OUT_FOR_SERVICE_PAGE_TITLE = "toolsoutforservice.pageTitle";
  public static TOOLS_ON_SITE_PAGE_TITLE = "toolsonsite.pageTitle";
  public static TOOL_DETAILS_PAGE_TITLE = "tooldetails.pageTitle";
  public static TOOL_LOCATIONS_PAGE_TITLE = "location.pageTitle";

  public static TOOL_FILTERS_CLEAR_ALL = "toolfilters.clearall";
  public static TOOL_FILTERS_TITLE = "toolfilters.title";

  public static WORKFLOW_STATUS_AVAILABLE = "workflowstatus.available";
  public static WORKFLOW_STATUS_AWAIT_PO = "workflowstatus.awaitPo";
  public static WORKFLOW_STATUS_IN_PROCESS = "workflowstatus.inProcess";
  public static WORKFLOW_STATUS_RECEIVED = "workflowstatus.received";
  public static WORKFLOW_STATUS_REQUESTED = "workflowstatus.requested";
  public static WORKFLOW_STATUS_RETURNING = "workflowstatus.returning";

  public static OVERVIEW_MAINTENANCE_DUE = "overview.maintenanceDue";
  public static OVERVIEW_CALIBRATION_DUE = "overview.calibrationDue";

  public static OVERVIEW_MY_TOOLS = "overview.myTools";
  public static OVERVIEW_SERVICE_WARNINGS = "overview.serviceWarnings";

  public static HEADER_HOME = "header.home";
  public static HEADER_FIELD_SERVICE = "header.fieldservice";
  public static HEADER_CONTRACTS = "header.contracts";
  public static HEADER_LOCATIONS = "header.locations";
  public static HEADER_TOOLS = "header.tools";
  public static HEADER_ADMIN = "header.admin";
  public static HEADER_REMINDERS = "header.reminders";
  public static HEADER_SERVICE_REQUEST = "header.servicerequest";
  public static HEADER_PURCHASE_ORDER = "header.purchaseorder";
  public static HEADER_MY_SOFTWARE = "header.mySoftware";
  public static BUTTON_LOGIN = "button.login";
  public static BUTTON_CONTINUE = "button.continue";
  public static BUTTON_CANCEL = "button.cancel";
  public static BUTTON_CLEAN = "button.clean";
  public static BUTTON_DELETE = "button.delete";
  public static BUTTON_SUBMIT_REQUEST = "button.submitRequest";
  public static BUTTON_BACK_TO_HOME = "button.backToHome";
  public static BUTTON_SAVE = "button.save";
  public static BUTTON_EDIT = "button.edit";
  public static LABEL_REQUIRED = "label.required";

  public static USER_SETTINGS_TITLE = "usersettings.title";
  public static USER_SETTINGS_LANGUAGE = "usersettings.language";
  public static USER_SETTINGS_COMPANY = "usersettings.company";
  public static USER_SETTINGS_DEPARTMENTS = "usersettings.departments";
  public static USER_SETTINGS_BUTTON_LOGOUT = "button.logout";

  public static COMPANY_SELECT_PLACEHOLDER = "companyselect.placeholder";
  public static COMPANY_SELECT_MIN_LENGTH = "companyselect.minlength";
  public static DEPARTMENT_SELECT_ALL = "departmentselect.all";

  public static HOME_SEARCH_BY = "home.searchby";
  public static HOME_RESULTS = "home.results";
  public static TABLE_NO_RESULTS = "home.noResults";
  public static TOOL_SEARCH_TITLE = "toolsearch.title";

  public static TOOL_TOOL_ID = "tool.toolid";
  public static TOOL_MODEL_NUMBER = "tool.modelnumber";
  public static TOOL_SERIAL_NUMBER = "tool.serialnumber";
  public static TOOL_ARTICLE_NUMBER = "tool.articlenumber";
  public static TOOL_DESCRIPTION = "tool.description";
  public static TOOL_ACTIVATE_VALIDATION_TITLE = "tool.activateValidationTitle";
  public static TOOL_ACTIVATE_VALIDATION_CONTENT = "tool.activateValidationContent";
  public static BUTTON_OK = "button.OK";
  public static BUTTON_CONFIRM = "button.confirm";

  public static ERROR_NOT_AUTHORIZED_TITLE = "error.notAuthorizedTitle"; // "Not Authorized"
  public static ERROR_NOT_AUTHORIZED_MESSAGE = "error.notAuthorizedMessage"; // "You are not authorized to view this page or perform this action."
  public static ERROR_NOT_FOUND_TITLE = "error.notFoundTitle"; // "Not Found"
  public static ERROR_NOT_FOUND_MESSAGE = "error.notFoundMessage"; // "Although your network connection to our website was established successfully, the web server was unable to locate the requested page, file, or resource. This error often happens when an incorrect URL is entered, a link is outdated, or we have made changes that have affected the requested resource. To resolve this issue, we recommend verifying the URL to ensure it is correct."
  public static ERROR_BAD_REQUEST_TITLE = "error.badRequestTitle"; // "Bad Request"
  public static ERROR_BAD_REQUEST_MESSAGE = "error.badRequestMessage"; // "Sorry, we were unable to process your request due to a problem with the information you provided. Please review your input and try again."
  public static ERROR_SERVER_ERROR_TITLE = "error.serverErrorTitle"; // "Server Error"
  public static ERROR_SERVER_ERROR_MESSAGE = "error.serverErrorMessage"; // "There was an issue with the server while processing your request. Please try again later or contact support for assistance."
  public static ERROR_CLIENT_SIDE_TITLE = "error.clientSideTitle"; //        "Error encountered on the page",
  public static ERROR_CLIENT_SIDE_MESSAGE = "error.clientSideMessage"; //    "An error has occurred on this page. Please try refreshing the page or contact support if the problem persists."
  public static ERROR_ADDITIONAL_DETAILS = "error.additionalDetails";
  public static BUTTON_START_REQUEST = "button.startRequest";
  public static BUTTON_START_CHECKOUT = "button.startCheckout";

  public static SERVICE_REQUEST_REQUESTED_SERVICE_PLACEHOLDER =
    "servicerequest.requestedserviceplaceholder";
  public static SERVICE_REQUEST_REQUESTED_SERVICE = "servicerequest.requestedservice";
  public static SERVICE_REQUEST_MAX_PRICE_PLACEHOLDER = "servicerequest.maxpriceplaceholder";
  public static SERVICE_REQUEST_MAX_PRICE_PERCENT = "servicerequest.maxpricepercent";
  public static SERVICE_REQUEST_CUSTOMER_COMMENTS = "servicerequest.toolcomments";
  public static SERVICE_REQUEST_FORM_ERRORS = "servicerequest.formErrors";
  public static SERVICE_REQUEST_TOOLS = "servicerequest.tools";
  public static SERVICE_REQUEST_OTHER_SERVICE = "servicerequest.otherservice";
  public static SERVICE_REQUEST_SUBMIT_TRACK_TOOLS = "servicerequest.submittracktools";
  public static SERVICE_REQUEST_REMOVE_ALL = "servicerequest.removeall";
  public static PURCHASE_ORDER_REMOVE_ALL = "purchaseorder.removeall";
  public static PURCHASE_ORDER_TOOL_SERVICE_PRICE = "purchaseorder.toolserviceprice";
  public static PURCHASE_ORDER_TOOL_QUOTE = "purchaseorder.toolquote";
  public static SERVICE_REQUEST_STEP_SHIPPING = "servicerequest.stepShipping";
  public static SERVICE_REQUEST_STEP_DETAILS = "servicerequest.stepDetails";
  public static SERVICE_REQUEST_STEP_REVIEW = "servicerequest.stepReview";
  public static SERVICE_REQUEST_STEP_CONFIRMATION = "servicerequest.stepConfirmation";
  public static SERVICE_REQUEST_STEP_SHIPPING_TITLE = "servicerequest.shippingtitle";
  public static SERVICE_REQUEST_STEP_SENDER = "servicerequest.sender";
  public static SERVICE_REQUEST_STEP_COMPANY = "servicerequest.company";
  public static SERVICE_REQUEST_STEP_ADDRESS = "servicerequest.address";
  public static SERVICE_REQUEST_STEP_SHIPPING_PLACEHOLDER = "servicerequest.shippingplaceholder";
  public static SERVICE_REQUEST_STEP_OTHER_ADDRESS = "servicerequest.otheraddress";
  public static SERVICE_REQUEST_STEP_CONTACT_TITLE = "servicerequest.contacttitle";
  public static SERVICE_REQUEST_STEP_RECEIVER_TITLE = "servicerequest.receivertitle";
  public static SERVICE_REQUEST_STEP_SHOP = "servicerequest.shop";
  public static SERVICE_REQUEST_STEP_SHOP_PLACEHOLDER = "servicerequest.shopplaceholder";
  public static SERVICE_REQUEST_STEP_CONTACT_NAME = "servicerequest.contactname";
  public static SERVICE_REQUEST_STEP_DOCUMENTS = "servicerequest.documents";
  public static SERVICE_REQUEST_STEP_PURCHASE_ORDER_TITLE = "servicerequest.purchaseordertitle";
  public static SERVICE_REQUEST_STEP_TRACKING_NUMBER_TITLE = "servicerequest.trackingNumberTitle";
  public static SERVICE_REQUEST_STEP_REMARKS = "servicerequest.remarks";
  public static SERVICE_REQUEST_CONTACT_EMAIL = "servicerequest.contactemail";
  public static SERVICE_REQUEST_CONTACT_PHONE = "servicerequest.contactphone";
  public static SERVICE_REQUEST_STEP_CONFIRMATION_MESSAGE = "servicerequest.confirmationMessage";
  public static SERVICE_REQUEST_STEP_CONFIRMATION_MESSAGE_2 = "servicerequest.confirmationMessage2";
  public static BUTTON_SERVICE_REQUEST_DOWNLOAD_FILE = "button.serviceRequestDownloadFile";
  public static BUTTON_EXPORT_TO_EXCEL = "button.exportToExcel";
  public static BUTTON_ADD_COLUMN = "button.addColumn";
  public static BUTTON_ADD = "button.add";
  public static BUTTON_REMOVE = "button.remove";
  public static BUTTON_RENAME = "button.rename";
  public static BUTTON_DEACTIVATE = "button.deactivate";
  public static BUTTON_ACTIVATE = "button.activate";
  public static BUTTON_SELECT_ALL = "button.selectall";
  public static BUTTON_UNSELECT_ALL = "button.unselectall";
  public static PURCHASE_ORDER_TOOLS = "purchaseorder.tools";
  public static PURCHASE_ORDER_ENTER_PO_STEP_NAME = "purchaseOrder.enterPOStepName";

  public static PURCHASE_ORDER_ENTER_PO_TITLE = "purchaseOrder.enterPOTitle";
  public static PURCHASE_ORDER_STEP_SHIPPING = "purchaseOrder.stepShipping";
  public static PURCHASE_ORDER_PROCESS_TYPE = "purchaseorder.processtype";
  public static PURCHASE_ORDER_SHIP_TO = "purchaseorder.shipto";
  public static PURCHASE_ORDER_ORDER_SUMMARY = "purchaseOrder.orderSummary";
  public static PURCHASE_ORDER_TOTAL = "purchaseOrder.total";
  public static PURCHASE_ORDER_STEP_CONFIRMATION = "purchaseOrder.stepConfirmation";

  public static PURCHASE_ORDER_STEP_CONFIRMATION_MESSAGE = "purchaseOrder.stepConfirmationMessage";
  public static PURCHASE_ORDER_STEP_CONFIRMATION_MESSAGE_2 =
    "purchaseOrder.stepConfirmationMessage2";
  public static BUTTON_SUBMIT_PURCHASE_ORDER = "button.submitPurchaseOrder";
  public static BUTTON_PURCHASE_ORDER_DOWNLOAD_FILE = "button.purchaseOrderDownloadFile";
  public static PURCHASE_ORDER_SUMMARY_TOOLS = "purchaseOrder.summaryTools";
  public static PURCHASE_ORDER_FINAL_STEP_PO_SECTION_NAME = "purchaseOrder.finalStepPoSectionName";

  public static PURCHASE_ORDER_FINAL_STEP_PO_NUMBER_SECTION_NAME =
    "purchaseOrder.finalStepPoNumberSectionName";
  public static PURCHASE_ORDER_FINAL_STEP_PROCESS_TYPE_SECTION_NAME =
    "purchaseOrder.finalStepProcessTypeSection";
  public static PURCHASE_ORDER_FINAL_STEP_REMARKS_SECTION = "purchaseOrder.finalStepRemarksSection";
  public static PURCHASE_ORDER_SUPPORTING_DOCUMENTS = "purchaseOrder.supportingDocuments";
  public static PURCHASE_ORDER_MY_TOOLS = "purchaseOrder.purchaseOrderMyTools";
  public static PURCHASE_ORDER_MISSING_DOCUMENTS_TITLE = "purchaseOrder.missingDocumentsTitle";
  public static PURCHASE_ORDER_MISSING_DOCUMENTS_MESSAGE = "purchaseOrder.missingDocumentsMessage";

  public static PURCHASE_ORDER_MARKING_AS_SCRAPPED_TITLE = "purchaseOrder.markingAsScrappedTitle";
  public static PURCHASE_ORDER_MARKING_AS_SCRAPPED_MESSAGE =
    "purchaseOrder.markingAsScrappedMessage";

  public static PURCHASE_ORDER_MARKING_AS_UNREPAIR_TITLE = "purchaseOrder.markingAsUnrepairTitle";
  public static PURCHASE_ORDER_MARKING_AS_UNREPAIR_MESSAGE =
    "purchaseOrder.markingAsUnrepairMessage";
  public static BUTTON_SPARE_PARTS_MANUALS = "button.sparePartsManuals";
  public static VALIDATION_MAX_LENGTH_MESSAGE = "validation.maxLengthMessage";
  public static CONTRACT_HEADER_COLUMN_DETAILED_STATUS = "contract.headerColumnDetailedStatus";
  public static CONTRACT_CONTRACT_REFERENCE = "contract.contractreference";
  public static CONTRACT_PO_NUMBER = "contract.ponumber";
  public static CONTRACT_TYPE = "contract.type";
  public static CONTRACT_START_DATE = "contract.startdate";
  public static CONTRACT_END_DATE = "contract.enddate";
  public static CONTRACT_STATUS = "contract.status";
  public static CONTRACT_ACTIVE = "contract.active";
  public static CONTRACT_INACTIVE = "contract.noactive";
  public static CONTRACT_ITEM_NUMBER = "contract.itemnumber";
  public static CONTRACT_ITEM_DESCRIPTION = "contract.itemdescription";
  public static CONTRACT_ITEM_TYPE = "contract.itemtype";
  public static CONTRACT_ITEM_ACTUAL_SERVICE = "contract.itemactualservice";
  public static BASKET_ITEM_SERVICE_REQUEST_ADDED_MESSAGE = "basket.serviceRequestAddedMessage";
  public static BASKET_ITEM_SERVICE_REQUEST_REMOVED_MESSAGE = "basket.serviceRequestRemovedMessage";
  public static BASKET_ITEM_PURCHASE_ORDER_ADDED_MESSAGE = "basket.purchaseOrderAddedMessage";
  public static BASKET_ITEM_PURCHASE_ORDER_REMOVED_MESSAGE = "basket.purchaseOrderRemovedMessage";

  public static FOOTER_BRANDING_AC = "footer.brandingAC";
  public static FOOTER_BRANDING_CP = "footer.brandingCP";

  public static COMPANY_REMINDER_REMOVE_DIALOG_TITLE = "companyReminder.removeDialogTitle";
  public static COMPANY_REMINDER_REMOVE_DIALOG_CONTENT = "companyReminder.removeDialogContent";

  public static REMINDER_COUNTRY = "reminder.country";
  public static REMINDER_COMPANY = "reminder.company";
  public static REMINDER_NEXT_REMIND = "reminder.nextRemind";
  public static REMINDER_TYPE = "reminder.type";
  public static REMINDER_INTERVAL = "reminder.interval";
  public static REMINDER_DAYS_BEFORE = "reminder.daysbefore";
  public static REMINDER_DAYS_AFTER = "reminder.daysafter";
  public static REMINDER_TO = "reminder.to";
  public static REMINDER_CC = "reminder.cc";
  public static REMINDER_BCC = "reminder.bcc";

  public static LOCALIZATION_REMOVE_DIALOG_TITLE = "localization.removeDialogTitle";
  public static LOCALIZATION_REMOVE_DIALOG_CONTENT = "localization.removeDialogContent";

  public static PENDING_USERS_CONFIRM_REMOVE_DIALOG_TITLE = "pendingUsers.confirmREmoveDialogTitle";

  public static USERS_REMOVE_DIALOG_TITLE = "users.removeDialogTitle";
  public static USERS_REMOVE_DIALOG_CONTENT = "users.removeDialogContent";

  public static REMINDERS_REMOVE_DIALOG_TITLE = "reminders.removeDialogTitle";
  public static REMINDERS_REMOVE_DIALOG_CONTENT = "reminders.removeDialogContent";
  public static REMINDERS_NO_REMINDERS_FOUND = "reminders.noremindersfound";
  public static REMINDERS_ALL_REMINDERS_CREATED = "reminders.allreminderscreated";

  public static REMINDERS_CREATE_NEW = "reminders.createnew";
  public static REMINDERS_CREATE_DEFAULT = "reminders.createdefault";

  public static LOCATIONS_REMOVE_TOOL_DIALOG_TITLE = "locations.removeToolDialogTitle";
  public static LOCATIONS_REMOVE_TOOL_DIALOG_CONTENT = "locations.removeToolDialogContent";

  public static TOOL_LOCATION = "tool.location";
  public static TOOL_TOOLS_COUNT = "tool.toolscount";
  public static TOOLS_LOCATION = "tools.location";

  public static INTERVALS_DAYS = "intervals.days";
  public static INTERVALS_MONTHS = "intervals.months";
  public static INTERVALS_YEARS = "intervals.years";
  public static ICON_INFORMATION_TITLE = "icon.informationTitle";

  public static PAGINATION_FIRST_PAGE = "pagination.firstPage";
  public static PAGINATION_LAST_PAGE = "pagination.lastPage";
  public static PAGINATION_NEXT_PAGE = "pagination.nextPage";
  public static PAGINATION_PREVIOUS_PAGE = "pagination.previousPage";
  public static PAGINATION_ITEMS_PER_PAGE = "pagination.itemsPerPage";
  public static PAGINATION_PAGE = "pagination.page";
  public static PAGINATION_PAGESIZE = "pagination.pageSize";
  public static PAGINATION_RESULTS = "pagination.results";
  public static PENDING_USERS_CONFIRM_GOTO_AZURE_DIALOG_TITLE =
    "pendingUsers.confirmGotoAzureDialogTitle";
  public static PENDING_USERS_CONFIRM_GOTO_AZURE_DIALOG_CONTENT =
    "pendingUsers.confirmGotoAzureDialogContent";
  public static QUICK_GRID_FILTER_SEARCH = "quickGridFilter.search";

  public static DEPARTMENT_NO_FILTER_SET = "department.nofilterset";
  public static USERS_NO_DEPARTMENT_SELECTION = "users.noDepartmentSelection";
  public static DEPARTMENT_NO_DEPARTMENT_SELECTION = "department.noDepartmentSelection";

  // Release 2.2.7

  public static USER_ADDITIONAL_APPLICATIONS_TITLE = "user.additionalApplicationsTitle";
  public static APPLICATION_FS = "application.fs";
  public static APPLICATION_EA = "application.ea";

  // Release 2.2.7 end
  // --------------------

  // Release 2.2.8

  public static ANNOUNCEMENT_TITLE = "announcement.title";
  public static ANNOUNCEMENT_CONTENT = "announcement.content";
  public static BUTTON_CLOSE = "button.close";

  // Release 2.2.8 end
  // ------------------------
  // Release 2.3.1
  public static SERVICE_REQUEST_STEP_IS_SHIPPING_REQUESTED =
    "serviceRequest.stepIsShippingRequested";
  public static SERVICE_REQUEST_STEP_SHIPPING_REQUEST_TITLE = "serviceRequest.shippingRequestTitle";
  public static SHIPPING_PACKAGES_REQUEST_FORM_TITLE = "shippingPackagesRequestForm.title";
  public static SHIPPING_PACKAGES_REQUEST_FORM_WEIGHT = "shippingPackagesRequestForm.weight";
  public static SHIPPING_PACKAGES_REQUEST_FORM_DESCRIPTION =
    "shippingPackagesRequestForm.description";
  public static SHIPPING_PACKAGES_PACKAGE_FORM_TITLE = "shippingPackages.packageFormTitle";
  public static SHIPPING_PACKAGES_ADD_PACKAGE = "shippingPackages.addPackage";
  public static SHIPPING_PACKAGES_PACKAGE_FORM_METRIC_CM = "shippingPackages.packageFormMetricCm";
  public static SHIPPING_PACKAGES_PACKAGE_FORM_METRIC_KG = "shippingPackages.packageFormMetricKg";
  public static SHIPPING_PACKAGES_PACKAGE_FORM_IMPERIAL_IN =
    "shippingPackages.packageFormImperialIn";
  public static SHIPPING_PACKAGES_PACKAGE_FORM_IMPERIAL_LB =
    "shippingPackages.packageFormImperialLb";
  public static SERVICE_REQUEST_STEP_SHIPPING_PACKAGES_REVIEW =
    "serviceRequest.shippingPackagesReview";

  public static SHIPPING_PACKAGES_PACKAGE_FORM_OPTION_TYPE_SMALL =
    "shippingPackages.packageFormOptionTypeSmall";
  public static SHIPPING_PACKAGES_PACKAGE_FORM_OPTION_TYPE_MEDIUM =
    "shippingPackages.packageFormOptionTypeMedium";
  public static SHIPPING_PACKAGES_PACKAGE_FORM_OPTION_TYPE_LARGE =
    "shippingPackages.packageFormOptionTypeLarge";

  public static SHIPPING_PACKAGES_PACKAGE_FORM_OPTION_TYPE_EXTRA_LARGE =
    "shippingPackages.packageFormOptionTypeExtraLarge";

  public static SHIPPING_PACKAGES_REQUEST_FORM_DIMENSION_OPTIONS =
    "shippingPackagesRequestForm.dimensionOptions";

  public static SERVICE_REQUEST_SHIPPING_PACKAGES_TOTAL_PACKAGES =
    "serviceRequest.shippingPackagesTotalPackages";

  public static SERVICE_REQUEST_SHIPPING_PACKAGES_SUMMARY =
    "serviceRequest.shippingPackagesSummary";

  public static SERVICE_REQUEST_SHIPPING_PACKAGES_ADDITIONAL_INFO =
    "serviceRequest.shippingPackagesAdditionalInfo";

  public static SERVICE_REQUEST_SHIPPING_PACKAGES_PICKUP_DATE =
    "serviceRequest.shippingPackagesPickupDate";

  public static SERVICE_REQUEST_SHIPPING_PACKAGES_BUSINESS_HOURS =
    "serviceRequest.shippingPackagesBusinessHours";

  public static LABEL_START_TIME_MUST_BE_BEFORE_END_TIME = "label.startTimeMustBeBeforeEndTime";

  public static SERVICE_REQUEST_STEP_SHIPPING_PACKAGES_MAX_DIMENSIONS_NOTE =
    "serviceRequest.shippingPackagesMaxDimensionsNote";

  public static SERVICE_REQUEST_STEP_SHIPPING_PACKAGES_NO_DANGEROUS_GOODS_ALLOWED =
    "serviceRequest.shippingPackagesNoDangerousGoodsAllowed";

  public static SERVICE_REQUEST_SHIPMENT_CREATION_FAILED_CONTACT_SUPPORT =
    "serviceRequest.shipmentCreationFailedContactSupport";

  public static SERVICE_REQUEST_SHIPMENT_CREATION_FAILED_TITLE =
    "serviceRequest.shipmentCreationFailedTitle";

  public static SERVICE_REQUEST_BUTTON_PRINT_LABEL = "serviceRequest.buttonPrintLabel";

  public static SERVICE_REQUEST_SHIPPING_LABEL_INSTRUCTIONS =
    "serviceRequest.shippingLabelInstructions";

  public static CUSTOMER_SETTINGS_SHIPPING_NOTES = "customerSettings.shippingNotes";

  public static VALIDATION_GENERIC_MESSAGE = "validation.genericMessage";

  public static VALIDATION_MIN_MESSAGE = "validation.minMessage";

  public static VALIDATION_MAX_MESSAGE = "validation.maxMessage";

  public static SERVICE_REQUEST_STEP_NO_SHIP_TO_ADDRESS = "serviceRequest.stepNoShipToAddress";

  public static SERVICE_REQUEST_STEP_NO_SHIP_FROM_ADDRESS = "serviceRequest.stepNoShipFromAddress";

  public static TECH_COVER_CONTACT_FAM_CODE_INVALID = "techCoverContact.famCodeInvalid";

  public static TOOL_STATUS_LAST_SHIPPPING_LABEL_LINK = "toolStatus.lastShippingLabelLink";

  public static TOOL_STATUS_LAST_SHIPPING_LABEL_TO_DOWNLOAD =
    "toolStatus.lastShippingLabelToDownload";

  // Release 2.3.1 end
  // ------------------------

  // Release 2.3.2

  public static ADMIN_BACK_BUTTON_TITLE = "admin.backButtonTitle";
  public static BUTTON_BACK = "button.back";
  public static TECH_COVER_CREATE_TICKET_ISSUE_TITLE = "techCoverCreateTicket.issueTitle";
  public static TECH_COVER_CREATE_TICKET_ISSUE_DESCRIPTION =
    "techCoverCreateTicket.issueDescription";
  public static TECH_COVER_CREATE_TICKET_BUSINESS_IMPACT = "techCoverCreateTicket.businessImpact";
  public static TECH_COVER_CREATE_TICKET_PRODUCT_IMPACT = "techCoverCreateTicket.productImpact";
  public static TECH_COVER_CREATE_TICKET_SELECT_PRODUCT_WITH_ISSUES =
    "techCoverCreateTicket.selectProductWithIssues";
  public static TECH_COVER_CREATE_TICKET_SELECT_PRODUCT_RELEASE =
    "techCoverCreateTicket.selectProductRelease";
  public static TECH_COVER_CREATE_TICKET_LOCAL_PRIORITY = "techCoverCreateTicket.localPriority";
  public static TECH_COVER_CREATE_TICKET_SUPPORTING_DOCUMENTS =
    "techCoverCreateTicket.supportingDocuments";
  public static TECH_COVER_CREATE_TICKET_TITLE = "techCoverCreateTicket.title";
  public static SUCCESS_TITLE = "success.title";
  public static TECH_COVER_CREATE_TICKET_SUCCESS_MESSAGE_TITLE =
    "techCoverCreateTicket.successMessageTitle";
  public static TECH_COVER_CREATE_TICKET_SUCCESS_MESSAGE_WHAT_HAPPENS_NOW_TITLE =
    "techCoverCreateTicket.successMessageWhatHappensNowTitle";
  public static TECH_COVER_CREATE_TICKET_SUCCESS_MESSAGE_WHAT_HAPPENS_NOW_CONTRACT_CUSTOMER_DESCRIPTION =
    "techCoverCreateTicket.successMessageWhatHappensNowContractCustomerDescription";
  public static TIME_VALUE_HOURS = "timeValue.hours";
  public static TECH_COVER_TICKET_NUMBER = "techCoverTicket.number";
  public static TECH_COVER_TICKET_PRIORITY_LOWEST = "techCoverTicket.priorityLowest";
  public static TECH_COVER_TICKET_PRIORITY_LOW = "techCoverTicket.priorityLow";
  public static TECH_COVER_TICKET_PRIORITY_MEDIUM = "techCoverTicket.priorityMedium";
  public static TECH_COVER_TICKET_PRIORITY_HIGH = "techCoverTicket.priorityHigh";
  public static TECH_COVER_TICKET_PRIORITY_HIGHEST = "techCoverTicket.priorityHighest";
  public static TECH_COVER_CREATE_TICKET_CONTRACT_NUMBER = "techCoverCreateTicket.contractNumber";
  public static VALIDATION_INTEGER_PATTERN_MESSAGE = "validation.integerPatternMessage";

  // Release 2.4.4
  public static VALIDATION_INTERNATIONAL_PHONE_FORMAT = "validation.internationalPhoneFormat";

  // Salesforce migration
  public static SALESFORCE_MIGRATION_TITLE = "salesforceMigration.title";
  public static SALESFORCE_MIGRATION_CONTACT = "salesforceMigration.contact";
}
